"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importStar(require("styled-components"));
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const onStore = () => {
    if (typeof window.onGoToStore === 'function') {
        window.onGoToStore();
    }
};
function TrialNotification({ license }) {
    const now = +new Date();
    const expirationDate = +new Date(license.expireAt);
    const days = Math.round((expirationDate - now) / (1000 * 60 * 60 * 24));
    return ((0, jsx_runtime_1.jsxs)(Container, { "data-e2e": 'TrialNotification_Container', children: [(0, jsx_runtime_1.jsxs)(Content, { "data-e2e": 'TrialNotification_Content', children: [(0, jsx_runtime_1.jsx)(Label, { "$fontSize": "48px", "data-e2e": 'TrialNotification_Label', children: (0, i18n_1.Localized)(i18n_1.Strings.settings.notifications.trial, {
                            count: days,
                        }) }), (0, jsx_runtime_1.jsxs)(Label, { "$marginLeft": "0px", "data-e2e": 'TrialNotification_Label', children: [(0, i18n_1.Localized)(i18n_1.Strings.settings.notifications.remaining, { count: days }), ' ', (0, i18n_1.Localized)(i18n_1.Strings.settings.notifications.freeTrial)] })] }), (0, jsx_runtime_1.jsx)(ButtonContainer, { "data-e2e": 'TrialNotification_ButtonContainer', children: (0, jsx_runtime_1.jsx)(StyledPrimaryButton, { onClick: onStore, size: ui_1.ButtonSize.Small, "data-e2e": 'TrialNotification_StyledPrimaryButton', children: (0, i18n_1.Localized)(i18n_1.Strings.common.goToStore) }) })] }));
}
exports.default = TrialNotification;
const Label = styled_components_1.default.span `
  color: ${props => props.theme.white};
  font-size: ${props => props.$fontSize || '18px'};

  margin-bottom: 10px;

  ${ui_1.device.tablet((0, styled_components_1.css) `
    margin-bottom: 0;
    margin-right: 10px;
    margin-left: ${props => props.$marginLeft || '24px'};
  `)};
`;
const Container = styled_components_1.default.div `
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  background-color: ${({ theme }) => theme.designSystem.contentBackground};

  ${ui_1.device.tablet((0, styled_components_1.css) `
    height: 110px;
    flex-direction: row;
    justify-content: space-between;
  `)};

  ${ui_1.device.laptopS((0, styled_components_1.css) `
    margin-left: 35px;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    border-left: 5px solid ${({ theme }) => theme.greenSecondary};
  `)};
`;
const Content = styled_components_1.default.div `
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  font-size: 14px;

  margin-top: 35px;
  margin-bottom: 20px;

  ${ui_1.device.tablet((0, styled_components_1.css) `
    margin-top: 0;
    margin-bottom: 0;
    flex-direction: row;
  `)};

  ${ui_1.device.laptopS((0, styled_components_1.css) `
    width: 75%;
    justify-content: left;
  `)};
`;
const ButtonContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: center;

  ${ui_1.device.laptopS((0, styled_components_1.css) `
    width: 25%;
    justify-content: left;
    max-width: 240px;
  `)};
`;
const StyledPrimaryButton = (0, styled_components_1.default)(ui_1.PrimaryButton) `
  height: 48px;
  min-width: 200px;
  font-size: 16px;
  border-radius: 4px;
  margin-bottom: 45px;
  white-space: nowrap;

  ${ui_1.device.tablet((0, styled_components_1.css) `
    margin-bottom: 0;
    margin-right: 30px;
  `)};

  ${ui_1.device.laptopS((0, styled_components_1.css) `
    width: 25%;
    margin-left: 0;
  `)};
`;
